import type {FetchBaseQueryError} from '@reduxjs/toolkit/query'

export type Certificate = {
  subject: string
  issuer: string
  notBefore: number
  notAfter: number
  fetchedFromAcme: boolean
  connector: Connector
}

export enum RedirectStatus {
  ENABLED = 'ENABLED',
  BROWSER_ONLY = 'BROWSER_ONLY',
  DISABLED = 'DISABLED',
}

export type Connector = {
  enabled: boolean
  redirectStatus: RedirectStatus
  port: number
}

type Authorization = {
  domain: string
  domainDescription: string
  challengeFileName: string
  challengeFileContent: string
}
export type PendingAcmeOrder = {
  authorizations: ReadonlyArray<Authorization>
}

export enum CertificateInstallationTabs {
  UPLOAD = 'UPLOAD',
  FETCH = 'FETCH',
}

export type HttpsState = {
  error: FetchBaseQueryError | null
}
